module.exports = __webpack_public_path__ + "static/media/background-4.49de40e9.jpg";